import React from 'react';
import { QueryRenderer, graphql } from 'react-relay';
import { RefreshIndicator } from 'material-ui';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import environment from '../../relay/environment';
import MergeVendors from './MergeVendors';

@connect(state => ({
  windowHeight: state.Responsive.get('windowHeight'),
}))
class Renderer extends React.Component {
  static propTypes = {
    windowHeight: PropTypes.number.isRequired,
    match: PropTypes.shape({
      params: PropTypes.shape({
        toKeepId: PropTypes.string,
        toMergeId: PropTypes.string,
      }),
    }).isRequired,
    history: PropTypes.shape({
      goBack: PropTypes.func,
    }).isRequired,
  }

  render() {
    const {
      windowHeight, match: { params: { toKeepId, toMergeId } },
      history: { goBack },
    } = this.props;
    const top = ((windowHeight - 161) / 2) + 161;

    const loadingEl = (<RefreshIndicator
      top={top}
      left={900}
      status='loading'
    />);
    const idString = `${toKeepId},${toMergeId}`;

    return (<QueryRenderer
      environment={environment}
      variables={{
        id: idString,
      }}
      query={graphql`
        query MergeVendorsRenderer_MergeDetails_Query($id: String!) {
          allVendors(id: $id) {
            edges {
              node {
                id,
                name,
                sabreCode,
                contacts,
                amenityPrograms
              }
            }
          }
        }
      `}
      render={({ error, props }) => {
        if (error) {
          return <div>{error.message}</div>;
        } else if (props) {
          const { allVendors: { edges: [toKeep, toMerge] } } = props;

          return (<MergeVendors
            toKeep={toKeep.node}
            toMerge={toMerge.node}
            goBack={goBack}
          />);
        }

        return loadingEl;
      }}
    />);
  }
}

export default Renderer;



// WEBPACK FOOTER //
// /src/components/Vendors/MergeVendorsRenderer.js